package com.patronat.top.ui.organisms.venue

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppTabSelector
import com.patronat.top.ui.models.VenueServiceItemData
import com.patronat.top.ui.molecules.actions.FormFooterActions
import com.patronat.top.ui.molecules.actions.TopActionRow
import com.patronat.top.ui.molecules.files.FileAttachmentRow
import com.patronat.top.ui.theme.AppIcons

@Composable
fun ServicesSection(
    services: List<VenueServiceItemData>,
    errorServiceIds: Set<String> = emptySet(),
    onServiceChange: (VenueServiceItemData) -> Unit,
    onServiceRemoveClick: (VenueServiceItemData) -> Unit,
    onAddServiceClick: () -> Unit,
    onUploadFileClick: () -> Unit,
    onCancelClick: () -> Unit,
    onSubmitClick: () -> Unit,
    modifier: Modifier = Modifier,
    selectedTabIndex: Int = 1,
    onTabSelected: (Int) -> Unit = {},
    tabs: List<String> = listOf("Заклад", "Послуги"),
    attachedFileName: String? = null,
    onRemoveFileClick: (() -> Unit)? = null,
    uploadButtonText: String = "Завантажити файлом",
    addButtonText: String = "Додати послугу",
    cancelButtonText: String = "Скасувати",
    submitButtonText: String = "Затвердити",
    serviceCardTitle: String = "Послуга, страва з меню і т.д.",
    uploadIcon: Painter? = null,
    fileIcon: Painter? = null,
    serviceHeaderIcon: Painter? = null,
    serviceFieldIcon: Painter? = null,
    submitLeadingIcon: Painter? = null
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        AppTabSelector(
            options = tabs,
            selectedIndex = selectedTabIndex,
            onOptionSelected = onTabSelected
        )

        TopActionRow(
            onUploadClick = onUploadFileClick,
            onAddClick = onAddServiceClick,
            uploadText = uploadButtonText,
            addText = addButtonText,
            uploadIcon = uploadIcon,
            addIcon = AppIcons.Plus
        )

        if (!attachedFileName.isNullOrBlank()) {
            FileAttachmentRow(
                fileName = attachedFileName,
                onRemoveClick = onRemoveFileClick,
                leadingIcon = fileIcon,
                trailingIcon = AppIcons.Close
            )
        }

        services.forEach { item ->
            val effectiveService = if (item.id in errorServiceIds) {
                item.copy(hasError = true)
            } else {
                item
            }
            ServiceItemCard(
                service = effectiveService,
                onServiceChange = onServiceChange,
                onRemoveClick = { onServiceRemoveClick(item) },
                title = serviceCardTitle,
                leadingIcon = serviceHeaderIcon,
                fieldLeadingIcon = serviceFieldIcon,
                removeIcon = AppIcons.Close
            )
        }

        Spacer(modifier = Modifier.height(8.dp))

        FormFooterActions(
            cancelText = cancelButtonText,
            submitText = submitButtonText,
            onCancelClick = onCancelClick,
            onSubmitClick = onSubmitClick,
            submitLeadingIcon = submitLeadingIcon
        )
    }
}
